var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopPointMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FF3100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.5C15.925 8.5 11 13.425 11 19.5C11 27.75 22 35.5 22 35.5C22 35.5 33 27.75 33 19.5C33 13.425 28.075 8.5 22 8.5ZM22 23.25C19.929 23.25 18.25 21.571 18.25 19.5C18.25 17.429 19.929 15.75 22 15.75C24.071 15.75 25.75 17.429 25.75 19.5C25.75 21.571 24.071 23.25 22 23.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopPointMarker);
export default __webpack_public_path__ + "static/media/stop-point-marker.4d99ebdcd4edd267d9a08c2adbf23beb.svg";
export { ForwardRef as ReactComponent };